export class AccessKeyModel {
    constructor() {
        this.accessKey = ''
    }
    setDataFromApi(data) {
        this.accessKey = data.key
    }
}